var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWetherCoverCloudy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 894,
    height: 388,
    viewBox: "0 0 894 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_157_138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M797.963 177.592C793.12 157.697 779.907 139.782 760.581 126.907C741.255 114.032 717.014 106.995 692 107C650.336 107 614.15 126.167 596.129 154.217C574.94 156.074 555.345 164.213 541.108 177.07C526.871 189.928 518.998 206.597 519 223.875C519 262.561 557.781 294 605.5 294H792.917C832.707 294 865 267.82 865 235.562C865 204.707 835.446 179.696 797.963 177.592Z",
    fill: "#55225D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_157_138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M594.093 137.599C619.008 142.502 640.962 155.154 655.766 173.14C670.571 191.127 677.189 213.19 674.36 235.121C671.531 257.052 659.452 277.317 640.427 292.049C621.402 306.782 596.763 314.952 571.209 315H285.155C252.91 315.028 221.804 304.709 197.874 286.046C173.945 267.383 158.899 241.708 155.659 214.005C152.418 186.302 161.214 158.547 180.338 136.129C199.462 113.711 227.55 98.2286 259.15 92.6878V90.4422C259.134 78.5659 262.754 66.897 269.643 56.6179C276.532 46.3389 286.445 37.8152 298.378 31.9106C310.311 26.006 323.84 22.9305 337.593 22.9957C351.346 23.0609 364.835 26.2645 376.692 32.2818C394.94 16.7123 418.131 6.17324 443.325 2.00128C468.519 -2.17068 494.58 0.212415 518.203 8.84833C541.826 17.4842 561.947 31.9839 576.013 50.5083C590.08 69.0327 597.458 90.7473 597.213 112.898C597.213 121.431 596.173 129.515 594.093 137.599Z",
    fill: "#55225D"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_157_138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.365 252.191C324.806 254.978 340.173 262.167 350.536 272.388C360.899 282.609 365.533 295.146 363.552 307.609C361.572 320.071 353.117 331.586 339.799 339.958C326.482 348.33 309.234 352.972 291.346 353H91.1087C68.5373 353.016 46.7628 347.152 30.012 336.547C13.2612 325.942 2.7294 311.352 0.461008 295.609C-1.80738 279.867 4.34951 264.095 17.7365 251.356C31.1234 238.617 50.7853 229.819 72.9053 226.67V225.394C72.8938 218.645 75.4276 212.014 80.2499 206.173C85.0722 200.332 92.0116 195.489 100.365 192.133C108.718 188.778 118.188 187.03 127.815 187.067C137.442 187.104 146.885 188.925 155.185 192.344C167.958 183.497 184.192 177.508 201.827 175.137C219.463 172.767 237.706 174.121 254.242 179.028C270.778 183.935 284.863 192.175 294.709 202.702C304.556 213.228 309.721 225.568 309.549 238.155C309.549 243.004 308.821 247.598 307.365 252.191Z",
    fill: "#55225D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_157_138",
    x: 519,
    y: 107,
    width: 375,
    height: 201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_157_138"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_157_138",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_157_138",
    x: 155,
    y: 0,
    width: 555,
    height: 350,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_157_138"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_157_138",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_157_138",
    x: 0,
    y: 174,
    width: 399,
    height: 214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_157_138"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_157_138",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWetherCoverCloudy);
export default __webpack_public_path__ + "static/media/wether_cover_cloudy.17331f6a6336934ef7dea2e2dd940bf7.svg";
export { ForwardRef as ReactComponent };